export default __webpack_public_path__ + "static/media/event-details.b1fbf726.jpg";